import { CalendarCheck, Grid3X3, Home, Package, User } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

// Where a customer can go from anywhere in the app — the same places on the
// phone's bottom bar (each theme styles its own) and the desktop header
// (CustomerDesktopNav). Orders and Profile need an account; Subscribe only
// shows where the store offers subscriptions.
export const useCustomerNavItems = () => {
  const { user, storeSettings } = useAuth();
  const isGuest = !user;
  const offersSubscriptions = storeSettings?.tenant_features?.subscriptions === true;
  return [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/products', icon: Grid3X3, label: 'Categories' },
    ...(isGuest ? [] : [{ path: '/orders', icon: Package, label: 'Orders' }]),
    ...(!isGuest && offersSubscriptions ? [{ path: '/subscriptions', icon: CalendarCheck, label: 'Subscribe' }] : []),
    isGuest ? { path: '/login', icon: User, label: 'Login' } : { path: '/profile', icon: User, label: 'Profile' },
  ];
};

export const isNavItemActive = (path, pathname) => (path === '/' ? pathname === '/' : pathname.startsWith(path));
